import axios from 'axios';
import { buildPath } from './Base.api';

export function* getFilterSuggestions(query) {
    const url = buildPath('/get-filter-suggestions', query);
    return yield axios.get(url);
}